import { render, staticRenderFns } from "./feebackExpress.vue?vue&type=template&id=5e45b968&scoped=true"
import script from "./feebackExpress.vue?vue&type=script&lang=js"
export * from "./feebackExpress.vue?vue&type=script&lang=js"
import style0 from "./feebackExpress.vue?vue&type=style&index=0&id=5e45b968&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45b968",
  null
  
)

export default component.exports